<div class="main-content-container">
  <div class="main-container-body">
    <!-- <h3 class="mb-4">{{"field.label.token_management_screen" | translate | async}}</h3> -->
    <!-- <div class="page-title-container d-flex">
    <div class="page-title flex-grow-1 ng-star-inserted" *ngIf="!utilService.isMobile()">
      <div class="mb-0 ng-star-inserted">
        <div class="d-flex align-items-center mb-2">
          <div class="pl-2 pr-2 ng-star-inserted">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="backToTVScreen()">
              <img src="assets/images/grid-back.png">
            </a>
          </div>
          <div *ngIf="screen_number">{{"field.label.token_management_screen" | translate | async}} <span
          class="everyLwercase"> {{screen_number}}</span></div>
        </div>
      </div>
    </div>
  </div> -->
  @for (desk of list; track desk; let i = $index) {
    <div class="_card _card-wrapper token col-12 col-sm-12 col-md-6 col-lg-3 float-left"
      >
      <div class="_card-body" [ngxToggleFullscreen]="fullscreen[i]">
        <div class="_card-top-section">
          <label class="_card-label-heading">
            {{desk.service_item==undefined?desk.speciality_name:desk.service_item}}
            <!--    <button class="btn btn-icon float-right" title="Make Full Screen"
            (click)="switchFullscreen(i)">  // bug id --80656
            <i class="fa fa-expand"></i>
          </button> -->
        </label>
      </div>
      @if (desk.ballentine) {
        <div class="_card-middle-section _serving-token">
          @for (q of data; track q) {
            @if (q.desk_type == desk.desk_type && q.serviceItemName == desk.service_item) {
              <div class="_card-middle-section-without"
                >
                <div class="_card-left-section">
                  <!-- <div class="_card-left-top-section">
                  <label>Desk</label>
                </div> -->
                <div class="_card-left-bottom-section">
                  <div class="_desk-square">
                    <span>{{q.desk_name}}</span>
                  </div>
                </div>
              </div>
              <div class="_card-right-section">
                <!-- <div class="_card-right-top-section">
                <label>Token</label>
              </div> -->
              <div class="_card-right-bottom-section">
                <div class="_token-round _sq">
                  <span [ngClass]="q.stage=='Serving'?'color-blue':''">{{q.token}}</span>
                  @if (q.next_token) {
                    <span>{{q.next_token}}</span>
                  }
                  @if (q.second_token) {
                    <span>{{q.second_token}}</span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
  @if (!desk.ballentine) {
    <div class="_card-middle-section">
      <div class="_not-serving">
        {{'field.label.no_token_attach' | translate |async}}
      </div>
    </div>
  }
</div>
</div>
}
</div>
</div>